import React from 'react'

import { Container } from './styles'

const Radio = ({ label, name, disabled, ...rest }) => {
  return (
    <Container disabled={disabled}>
      {label}
      <input type="radio" name={name} disabled={disabled} {...rest} />
      <span></span>
    </Container>
  )
}

export default Radio
